import axios from 'CanExConfig/axios'

export const createBlockedCompany = async (id, { company, name }) => {
  const response = await axios(`/api/candidate/profiles/${id}/blocked_companies`, {
    method: 'POST',
    data: { company, name },
  })

  return response.data.result
}

export const fetchBlockedCompanies = async id => {
  const response = await axios(`/api/candidate/profiles/${id}/blocked_companies`, {
    method: 'GET',
  })

  return response.data.result
}

export const deleteBlockedCompany = async id => {
  const response = await axios(`/api/candidate/blocked_companies/${id}`, {
    method: 'DELETE',
  })

  return response.data.result
}
